import type { FC } from 'react';
import { useState } from 'react';
import {
  ACTION_VARIANTS,
  Button,
  ICON_NAMES,
  Textarea,
  TTextareaChangeEventHandler,
} from '@reverse-hr/design-system';
import { useParams } from 'react-router-dom';
import type { TProfileInfoHeaderRouteParams } from '@components/Molecules/ProfileInfoHeader/ProfileInfoHeader.types';
import { useStoreActions } from 'easy-peasy';
import { postFeedbackMessageSelector } from '@model/Candidate/Candidate.selectors';
import { useTranslation } from 'react-i18next';

export const ChatFooter: FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.chat',
  });

  const [message, setMessage] = useState<string>('');
  const [isSending, setIsSending] = useState<boolean>(false);
  const postFeedbackMessage = useStoreActions(postFeedbackMessageSelector);

  const { jobId, candidateId } = useParams<TProfileInfoHeaderRouteParams>();

  const isSendButtonDisabled = !message || isSending;

  const onMessageChange: TTextareaChangeEventHandler = value =>
    setMessage(value);

  const onSendClick = async (): Promise<void> => {
    if (!jobId || !candidateId) {
      return;
    }

    setIsSending(true);

    try {
      await postFeedbackMessage({
        jobId,
        candidateId,
        content: message,
      });

      setMessage('');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <footer className="ev-chat__footer">
      <Textarea
        className="ev-chat__textarea"
        isDisabled={isSending}
        onChange={onMessageChange}
        rows={1}
        value={message}
      ></Textarea>

      <Button
        aria-label={t('sendButtonAriaLabel')}
        isDisabled={isSendButtonDisabled}
        leftIcon={ICON_NAMES.SHORT_RIGHT}
        onClick={onSendClick}
        variant={ACTION_VARIANTS.SECONDARY}
      />
    </footer>
  );
};
